import React, { useRef } from "react";
import { TextInput } from "react-admin";
import { useForm } from "react-final-form";

export const TenantAdminNameInput = (props: any) => {
  const form = useForm();
  const adminEmailRef = useRef<string>();

  return (
    <TextInput
      {...props}
      onChange={(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      ) => {
        const newValueNormalized = e.target.value
          .replace(/\W+/g, "")
          .toLocaleLowerCase();
        const tenantDomainNameValue = form.getFieldState("tenantDomainName")
          ?.value;
        if (!tenantDomainNameValue) {
          // Don't set any value if the tenant domain name is not set
          return;
        }

        const adminEmailFieldValue = form.getFieldState("adminEmailAddress")
          ?.value;
        if (
          adminEmailFieldValue &&
          adminEmailFieldValue !== adminEmailRef.current
        ) {
          // Don't set any value if the admin email field already has a user-supplied value
          return;
        }

        adminEmailRef.current = `${newValueNormalized}@${tenantDomainNameValue}`.toLocaleLowerCase();
        form.change("adminEmailAddress", adminEmailRef.current);
      }}
    />
  );
};
